import { ref, computed, onMounted } from 'vue'
import emailValidator from 'foundation/js/inputValidators/emailValidator'
import phoneValidator from '../../foundation/js/inputValidators/phoneValidator'
import nameValidator from '../../foundation/js/inputValidators/nameValidator'
import { useStore } from 'vuex'
import SuccessPage from '../SuccessPage/SuccessPage.vue'
import getLabel from 'foundation/js/getLabel'
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'

export default {
    name: 'SignUpForm',
    components: {
        SuccessPage
    },
    setup() {
        const store = useStore()
        const unSubmitted = ref(true)
        const showReceipt = computed(() => {
            return store.state.events.signUpCompleteShowReceipt
        })
        const isSubmitting = computed(() => store.state.events.isSubmitting)
        const signUpFailed = computed(() => store.state.events.signUpFailed)

        const eventId = computed(() => store.state.events.signUpEventId)
        const firstName = ref('')
        const lastName = ref('')
        const phone = ref('')
        const email = ref('')
        const consent = ref(false)

        const isValidEmail = computed(() => {
            return unSubmitted.value ? true : emailValidator(email.value)
        })

        const firstNameFilled = computed(() => {
            return unSubmitted.value && !firstName.value
                ? true
                : nameValidator(firstName.value)
        })

        const lastNameFilled = computed(() => {
            return unSubmitted.value && !lastName.value
                ? true
                : nameValidator(lastName.value)
        })

        const isValidPhone = computed(() => {
            return unSubmitted.value ? true : phoneValidator(phone.value)
        })

        const consentChecked = computed(() => {
            return unSubmitted.value ? true : consent.value
        })

        const onSubmit = function () {
            unSubmitted.value = false

            if (
                isValidEmail.value &&
                firstNameFilled.value &&
                lastNameFilled.value &&
                isValidPhone.value &&
                consentChecked.value
            ) {
                store.dispatch('events/signUpToEvent', {
                    eventId: eventId.value,
                    firstName: firstName.value,
                    lastName: lastName.value,
                    email: email.value,
                    phone: phone.value,
                    consent: consent.value
                })
            }
        }

        let first, last, close

        const tabTrap = function (e) {
            if (e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                last.focus()
            }

            if (!e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                first.focus()
            }
        }

        onMounted(() => {
            first = document.querySelector(
                '.kb-sign-up-form [data-order="first"]'
            )
            last = document.querySelector(
                '.kb-sign-up-form [data-order="last"]'
            )
            close = document.querySelector('.kb-page-overlay__close')
            onTransitionendCallback(
                {
                    opening() {
                        first.focus()
                    }
                },
                { persistent: true }
            )
        })

        function decodeHtml(html) {
            var txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        }

        return {
            firstName,
            lastName,
            phone,
            email,
            consent,
            isValidEmail,
            firstNameFilled,
            lastNameFilled,
            isValidPhone,
            consentChecked,
            showReceipt,
            isSubmitting,
            signUpFailed,
            onSubmit,
            getLabel,
            tabTrap,
            decodeHtml
        }
    }
}
